import { render, staticRenderFns } from "./sale-session-bundled-payments-table.vue?vue&type=template&id=45bed689&scoped=true&"
import script from "./sale-session-bundled-payments-table.ts?vue&type=script&lang=ts&"
export * from "./sale-session-bundled-payments-table.ts?vue&type=script&lang=ts&"
import style0 from "./sale-session-bundled-payments-table.scss?vue&type=style&index=0&id=45bed689&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bed689",
  null
  
)

export default component.exports